import { render, staticRenderFns } from "./findingItems.vue?vue&type=template&id=4c6bf846&"
import script from "./findingItems.vue?vue&type=script&lang=js&"
export * from "./findingItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports